'use strict';

import React, { PropTypes } from 'react';
import Grabbag from '../editor/Grabbag';
import Canvas from '../editor/Canvas';
import PageControlsTypes from '../constants/PageControlsTypes';
import Icon from '../atoms/Icon';
import GrabbagActionCreators from '../actions/GrabbagActionCreators';
import AlertActionCreators from '../actions/AlertActionCreators';
import AlertTypes from '../constants/AlertTypes';
import ImageUploader from '../utils/ImageUploader';
import PureRenderMixin from '../mixins/PureRenderMixin';
import parseStampSegment from '../utils/parseStampSegment';
import getDraftComposeRedirectTarget from '../utils/getDraftComposeRedirectTarget';
import NavigationContextTypes from '../constants/NavigationContextTypes';
import AppContext from '../AppContext';
import { DragDropMixin, NativeDragItemTypes, DropEffects } from 'react-dnd';

require('../editor/legacy/Dropzone.less');

const DraftComposePage = React.createClass({
  mixins: [DragDropMixin, PureRenderMixin],

  propTypes: {
    draft: PropTypes.object,
    stampSegment: PropTypes.string.isRequired
  },

  contextTypes: {
    router: PropTypes.func
  },

  statics: {
    willTransitionTo(transition, params) {
      const { stampSegment } = params;
      const [redirectTo, redirectParams] = getDraftComposeRedirectTarget(stampSegment);

      // First sanity check to avoid mounting if we know we don't need to.
      // Saves us runtime errors because editor doesn't work for anon users.
      if (redirectTo) {
        transition.redirect(redirectTo, redirectParams);
        return;
      }
    }
  },

  configureDragDrop(registerType) {
    registerType(NativeDragItemTypes.FILE, {
      dropTarget: {
        canDrop() {
          return true;
        },

        getDropEffect() {
          return DropEffects.COPY;
        },

        acceptDrop(item) {
          item.files.forEach(this.uploadImage);
        }
      }
    });
  },

  getPageControls() {
    const { draft, stampSegment } = this.props;
    const { isNewDraft } = parseStampSegment(stampSegment);

    if (!draft || isNewDraft) {
      return null;
    }

    return [PageControlsTypes.DRAFT_COMPOSE, { stampSegment }];
  },

  getNavigationContext() {
    return [NavigationContextTypes.DRAFT_COMPOSE];
  },

  getAppContext() {
    const [navigationContextType, navigationContextOptions] = this.getNavigationContext();
    const [pageControlsType, pageControlsOptions] = this.getPageControls() || [];

    return {
      navigationContextType,
      navigationContextOptions,
      pageControlsType,
      pageControlsOptions
    };
  },

  componentDidMount() {
    this.imageUploader = ImageUploader.createFileUploader();
    this.ensureHasAccess();
  },

  componentDidUpdate(prevProps) {
    if (Boolean(prevProps.draft) !== Boolean(this.props.draft) ||
        prevProps.stampSegment !== this.props.stampSegment) {

      this.ensureHasAccess();
    }
  },

  ensureHasAccess() {
    // Second sanity check to redirect if data arrives and tells us user may not edit.
    const { stampSegment, draft } = this.props;
    const [redirectTo, redirectParams] = getDraftComposeRedirectTarget(stampSegment, draft);
    const { router: { replaceWith }} = this.context;

    if (redirectTo) {
      replaceWith(redirectTo, redirectParams);
    }
  },

  render() {
    const { draft, stampSegment } = this.props;
    const { isDraft } = parseStampSegment(stampSegment);
    const fileDropState = this.getDropState(NativeDragItemTypes.FILE);

    return (
      <AppContext {...this.getAppContext()}>
        <div {...this.dropTargetFor(NativeDragItemTypes.FILE)}>
          {fileDropState.isDragging &&
            <div className='editor-DropZone'>
              <div className='editor-DropZone-body'>
                <div className='editor-DropZone-center'>
                  <div className='editor-GrabbagItem--upload'>
                    <Icon name='plus'
                          size='medium'
                          mode='stroke' />
                  </div>
                  <p>Drop here to upload</p>
                </div>
              </div>
            </div>
          }

          <Grabbag canAutoSave={isDraft} />
          <Canvas draft={draft} />
        </div>
      </AppContext>
    );
  },

  uploadImage(filePath) {
    GrabbagActionCreators.addGrabbagItem(filePath);

    function handleProgress(progress) {
      GrabbagActionCreators.updateGrabbagItem(filePath, { progress: progress });
    }

    this.imageUploader
      .uploadFile(filePath, handleProgress)
      .then(function (image) {
        GrabbagActionCreators.updateGrabbagItem(filePath, {
          progress: 0,
          image: image
        });
      })
      .catch(function () {
        AlertActionCreators.showAlert(AlertTypes.UPLOAD_USER_IMAGE_ERROR);
        GrabbagActionCreators.deleteGrabbagItem(filePath);
      });
  }
});

export default DraftComposePage;



/** WEBPACK FOOTER **
 ** ./pages/DraftComposePage.jsx
 **/